var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1213 10.5631C15.2923 11.7341 15.2923 13.6351 14.1213 14.8081C12.9503 15.9791 11.0493 15.9791 9.8763 14.8081C8.7053 13.6371 8.7053 11.7361 9.8763 10.5631C11.0493 9.3901 12.9493 9.3901 14.1213 10.5631",
    stroke: "currentColor",
    strokeWidth: 1.53261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.6831C3 12.0241 3.152 11.3721 3.446 10.7711V10.7711C4.961 7.67411 8.309 5.68311 12 5.68311C15.691 5.68311 19.039 7.67411 20.554 10.7711V10.7711C20.848 11.3721 21 12.0241 21 12.6831C21 13.3421 20.848 13.9941 20.554 14.5951V14.5951C19.039 17.6921 15.691 19.6831 12 19.6831C8.309 19.6831 4.961 17.6921 3.446 14.5951V14.5951C3.152 13.9941 3 13.3421 3 12.6831Z",
    stroke: "currentColor",
    strokeWidth: 1.53261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.42c75fde521b732241aab87ab4ac7ead.svg";
export { ForwardRef as ReactComponent };